import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./CompleteButton.module.css";
import Complete_Icon from "./Complete_Icon.svg";

/**
 *
 */
export function CompleteButton({ isLocked, onClick }) {
  return (
    <div onClick={isLocked ? null : onClick}>
      <button
        className={classNames(
          styles.imageContainer,
          isLocked ? styles.noPointerOnHover : styles.cursorPointerOnHover
        )}
      >
        <img src={Complete_Icon} className={classNames(styles.image)} />
      </button>
    </div>
  );
}

CompleteButton.propTypes = {
  isLocked: PropTypes.bool,
  isGrayed: PropTypes.bool,
  onClick: PropTypes.func,
};
